module.exports = __webpack_public_path__ + "img/big4-3.cce099b9.jpg";